import { useEffect, useMemo, useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import AddIcon from '@mui/icons-material/Add';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import Select from '../NodeTypeSelect'
import Input from '../NodeNameEntry'
import './style.css';
import { NODE_ADD } from '../../redux/actions/board';
import { MODAL_TOGGLE } from '../../redux/actions/app';
import { ID } from './config';
import { createDefaultNode } from '../../util/board';

const CreateNode = () => {

    const dispatch = useDispatch(),
    labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    { locale, modal } = useSelector( state => state.app ),
    target = useSelector( state => state.board.currentNode ),
    [ data, setData ] = useState( createDefaultNode() ),
    open = Boolean( modal === ID ),
    disabled = Boolean( !data || !data.name || !data.type );

    /**
     * @name onChange
     * @function
     * @description
     * @param {string} name 
     * @param {string} value 
     */
    const onChange = ( name, value ) => {
        setData({ ...data, [ name ]: value });
    }

    /**
     * @name add
     * @function
     * @description Adds a new node to memory then hides the modal
     */
    const add = () => {
        dispatch({ type: NODE_ADD, payload: { node: { ...data }, connectedTo: target?.id } });
        cancel();
    }

    /**
     * @name cancel
     * @function
     * @description Hides the modal
     */
    const cancel = () => {
        dispatch({ type: MODAL_TOGGLE });
        setData( createDefaultNode() );
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <Dialog open={ open } onClose={ cancel } className="coe__createNode">
            <DialogTitle>
                { 
                    target.name ?
                        labels.formatString(
                            labels.addAndConnect,
                            target.name 
                        ) :
                        labels.addNode 
                }
            </DialogTitle>
            <DialogContent>
                <Stack>
                    <Select onChange={ onChange } />
                    <Input onChange={ onChange } />
                    <Alert severity="info">{ labels.instructions }</Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button className="coe__createNode__add" aria-label={ labels.add } disabled={ disabled } onClick={ add } variant="contained" startIcon={ <AddIcon /> }>
                    { labels.add }
                </Button>
                <Button aria-label={ labels.cancel } variant="outlined" onClick={ cancel } startIcon={ <NotInterestedIcon /> }>
                    { labels.cancel }
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default CreateNode;